export default "__VITE_ASSET__pH4FtqLT__"